import React from 'react';
import LwtErrorBoundary from '@lwtears/lwt-common-frontend/lib/LwtErrorBoundary';
import AuthenticatedApp from './AuthenticatedApp';
import LoadingScreen from '@lwtears/lwt-common-frontend/lib/LoadingScreen';
import { AuthenticationGatekeeper } from '@lwtears/lwt-common-frontend/lib/AuthenticationGatekeeper';
import LwtApp from '@lwtears/lwt-common-frontend/lib/LwtApp';
import store from '../store';
import { applyVuex } from 'vuereact-combined';
applyVuex(store);
export default function App() {
    const [data, setData] = React.useState(null);
    return (<LwtApp>
      <AuthenticationGatekeeper Loading={<LoadingScreen />} onAuthenticated={response => {
            setData(response);
            return Promise.resolve();
        }} options={{ getUserParams: ['settings', 'featureToggles'] }}>
        <LwtErrorBoundary>
          <AuthenticatedApp data={data}/>
        </LwtErrorBoundary>
      </AuthenticationGatekeeper>
    </LwtApp>);
}
